/**
 * Public page layout — wraps marketing/info pages.
 * Uses shared TopNav + full footer.
 */

import { Outlet } from 'react-router-dom'
import TopNav from './TopNav'
import Footer from './Footer'

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <TopNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer variant="full" />
    </div>
  )
}
